<template>
  <div class="item-box-content">
    <el-table
      border
      ref="tableRef"
      :data="list"
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      height="378"
    >
      <el-table-column prop="taskNumber" label="任务编号">
        <template slot-scope="scope">
          <div>{{scope.row.taskNumber}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="taskType" label="任务类型"></el-table-column>
      <el-table-column prop="createUser" label="任务发起人"></el-table-column>
      <el-table-column prop="createDate" label="任务发起时间"></el-table-column>
      <el-table-column prop="state" label="当前状态"></el-table-column>
      <el-table-column prop="processUser" label="当前处理人"></el-table-column>
      <el-table-column prop="processDate" label="处理时间"></el-table-column>
      <el-table-column prop="result" label="处理结果"></el-table-column>
      <el-table-column prop="mark" label="备注"></el-table-column>
    </el-table>
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { queryTaskList } from '@/api/purchase/purchasePlanList'
import { isSuccess } from '@/util/tool'
export default {
  components: {
    pagination: pagination
  },
  data () {
    return {
      list: [],
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    getList() {
      const {
        pageSize,
        currentPage,
        $route
      } = this
      queryTaskList(currentPage, pageSize, $route.query.pcbId).then(res => {
        if (isSuccess(res)) {
          this.list = res.data.obj.records || []
          this.total = res.data.obj.total || 0
        }
      })
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
